<h1 class="page__title h2 mb-5">{{ 'emaildns_self_title' | translate }}</h1>
<wsb-atlas-button class="my-3" [label]="'emaildns_add_new_dns'" (btnClick)="openModalAddDns()"></wsb-atlas-button>
<wsb-atlas-grid
  #grid
  class="atlas-grid-simplest"
  class="mt-5"
  [columnDefs]="tableColumnDefs"
  [options]="tableGridOptions"
  [rowData]="tableRowData"
  [@gridIsLoaded]="gridAnimationState"
  [components]="components"
>
</wsb-atlas-grid>
<ng-template #modalDelete let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalDeleteDns()"
    (dismiss)="modalDeleteDnsDismiss()"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'emaildns_delete_ask' | translate }}{{ textDnsDelete }}"
  >
  </wsb-modal>
</ng-template>
<ng-template #modalDnsViewConfiguration let-c="close" let-d="dismiss">
  <wsb-email-dns-verify-congig-modal
    title="{{ 'emaildns_view_config' | translate }}"
    [idDomain]="idDomainViewConfig"
    (cancelEvent)="modalDnsViewConfigurationDismiss()"
  >
  </wsb-email-dns-verify-congig-modal>
</ng-template>
<ng-template #modalAddNewDns let-c="close" let-d="dismiss">
  <wsb-email-dns-new-modal
    title="{{ 'emaildns_add_new_dns' | translate }}"
    text="{{ 'emaildns_domain' | translate }}"
    placeholder="{{ 'domain_new_placeholder' | translate }}"
    alertText="{{ 'emaildns_new_heading' | translate }}"
    (add)="modalAddDns($event)"
    (cancelEvent)="modalAddDnsCancel()"
  >
  </wsb-email-dns-new-modal>
</ng-template>
